var lists_default = {
  "fontElementMap": "vIaRB",
  "orderedlist": "fm4Pd",
  "bulletedlist": "t-5Zo",
  "listItem": "qrGxT"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
